module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.library.js
 ** module id = 174
 ** module chunks = 0
 **/